import { useMutation } from 'react-query';
import { ApiSeatsRepository } from 'services/api/seats/ApiSeatsRepository';
import type { BasicApiResponse, DocumentRemoveAccessEntity } from 'services/api/seats/interfaces';

type DocumentRemoveAccessParam = {
  payload: DocumentRemoveAccessEntity;
};

export default function useDocumentRemoveAccessMutation() {
  const reactQuery = useMutation({
    mutationFn: documentRemoveAccess,
  });

  return { documentRemoveAccess: reactQuery.mutateAsync, documentRemoveAccessPromise: reactQuery.mutate, isLoading: reactQuery.isLoading };
}

const documentRemoveAccess = async (data: DocumentRemoveAccessParam): Promise<BasicApiResponse> => {
  const seatsApi = new ApiSeatsRepository();
  const response = await seatsApi.documentRemoveAccess(data.payload);

  return {
    state: response.state,
    message: response.message,
  };
};
